import type { GiftDTO } from '@/DTO/authDTO';
import { create } from 'zustand';

interface State {
    isVisible: boolean;
    callback: null | ((gift: GiftDTO | null) => void);
    update: (data: Partial<State>) => void;
}

export const useGiftsStore = create<State>(set => ({
    isVisible: false,
    callback: null,
    update: data => set(state => ({ ...state, ...data })),
}));
